import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { useLanguage } from '../contexts/LanguageContext';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import { CheckCircle, XCircle, Loader2 } from 'lucide-react';
import NavBar from '../components/NavBar';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const PaymentCallbackPage = () => {
  const { language } = useLanguage();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('processing');
  
  useEffect(() => {
    const token = searchParams.get('token');
    if (token) {
      processCallback(token);
    } else {
      setStatus('error');
    }
  }, []);
  
  const processCallback = async (token) => {
    try {
      const res = await axios.post(`${API}/payments/callback?token=${token}`);
      if (res.data.status === 'success') {
        setStatus('success');
      } else {
        setStatus('failed');
      }
    } catch (err) {
      setStatus('error');
    }
  };
  
  return (
    <div className="min-h-screen bg-slate-950" data-testid="payment-callback-page">
      <NavBar />
      <main className="pt-24 pb-12 px-4 flex items-center justify-center">
        <Card className="bg-slate-900/50 border-slate-800 max-w-md w-full">
          <CardContent className="py-12 text-center">
            {status === 'processing' && (
              <>
                <Loader2 className="h-16 w-16 animate-spin text-blue-400 mx-auto mb-4" />
                <h2 className="text-xl font-bold text-white mb-2">
                  {language === 'tr' ? 'Ödeme İşleniyor...' : 'Processing Payment...'}
                </h2>
                <p className="text-slate-400">
                  {language === 'tr' ? 'Lütfen bekleyin' : 'Please wait'}
                </p>
              </>
            )}
            {status === 'success' && (
              <>
                <CheckCircle className="h-16 w-16 text-emerald-400 mx-auto mb-4" />
                <h2 className="text-xl font-bold text-white mb-2">
                  {language === 'tr' ? 'Ödeme Başarılı!' : 'Payment Successful!'}
                </h2>
                <p className="text-slate-400 mb-6">
                  {language === 'tr' ? 'Aboneliğiniz aktifleştirildi. Şimdi değerlendirmelere başlayabilirsiniz.' : 'Your subscription is now active. You can start assessments now.'}
                </p>
                <Button onClick={() => navigate('/assessments')} className="bg-emerald-600 hover:bg-emerald-700" data-testid="go-assessments-btn">
                  {language === 'tr' ? 'Değerlendirmelere Git' : 'Go to Assessments'}
                </Button>
              </>
            )}
            {(status === 'failed' || status === 'error') && (
              <>
                <XCircle className="h-16 w-16 text-red-400 mx-auto mb-4" />
                <h2 className="text-xl font-bold text-white mb-2">
                  {language === 'tr' ? 'Ödeme Başarısız' : 'Payment Failed'}
                </h2>
                <p className="text-slate-400 mb-6">
                  {language === 'tr' ? 'Ödeme işlemi tamamlanamadı. Lütfen tekrar deneyin.' : 'Payment could not be completed. Please try again.'}
                </p>
                <Button onClick={() => navigate('/pricing')} className="bg-blue-600 hover:bg-blue-700" data-testid="retry-payment-btn">
                  {language === 'tr' ? 'Tekrar Dene' : 'Try Again'}
                </Button>
              </>
            )}
          </CardContent>
        </Card>
      </main>
    </div>
  );
};

export default PaymentCallbackPage;
